<template>
  <main id="contents" class="mypooq">
    <div v-if="isLiveTitle" class="top-padding">
      <live-title />
    </div>
    <my-pooq-title v-else-if="hasTitle"></my-pooq-title>
    <router-view name="myPooqContent" :key="$route.fullPath + componentKey"></router-view>
  </main>
</template>

<script>
import MyPooqTitle from '@/components/common/MyPooqTitle'
import { UPDATE_PAGING_CONTENT, UPDATE_MY_POOQ_CONTENT, SET_CURRENT_MENU, MENU } from '@/common/resources/const'
import { mapMutations } from 'vuex'
import _ from 'lodash'
import LiveTitle from '@/components/live/LiveTitle'
export default {
  name: 'MyPooqLayout',
  components: {
    LiveTitle,
    MyPooqTitle
  },
  data () {
    return {
      componentKey: 0
    }
  },
  computed: {
    isLiveTitle () {
      return _.get(this.$route, 'name', '') === 'like_channel'
    },
    hasTitle () {
      const routeName = _.get(this.$route, 'name', '')
      return routeName !== 'my'
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU])
  },
  mounted () {
    this[SET_CURRENT_MENU](MENU.MY) // DISABLE
    this.$events.$on(UPDATE_MY_POOQ_CONTENT, () => {
      this.componentKey += 1
    })
    this.$events.$on(UPDATE_PAGING_CONTENT, () => {
      this.componentKey += 1
    })
  },
  beforeDestroy () {
    this.$events.$off(UPDATE_MY_POOQ_CONTENT)
    this.$events.$off(UPDATE_PAGING_CONTENT)
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/my.scss"></style>
